import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=12056cdd&scoped=true&"
import script from "./icon.js?vue&type=script&lang=js&"
export * from "./icon.js?vue&type=script&lang=js&"
import style0 from "./icon.scss?vue&type=style&index=0&id=12056cdd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12056cdd",
  null
  
)

export default component.exports